export const fetchTfrTemplates = (state) => state.tfrTemplates.tfrTemplates;
